import UpdateVoiceFileRequest from '../../../../../Spirit/Admin/Interfaces/Models/UpdateVoiceFileRequest';

export default class AffirmationTranslationsUpdateRequest  {
	LangCode?: string = '';
	Name?: string = '';
	Description?: string = '';
	Text?: string = '';
	VoiceFiles: Array<UpdateVoiceFileRequest> = null;
	constructor(obj?: Partial<AffirmationTranslationsUpdateRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
